import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  searchlist: null,
  activitylist: null,
  captionslist: null,
  channelslist: null,
  channelsectionlist: null,
  commentslist: null,
  i18nlanguagelist: null,
  i18nregionslist: null,
  playlistitemslist: null,
  playlistslist: null,
  videocategorieslist: null,
  videoslist: null
};
export const callTypes = {
  list: "list",
  action: "action"
};
export const Slice = createSlice({

  name: "Youtube",
  initialState: initialState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      state.totalCount = 0;
    },
    // listFetched
    searchListFetched: (state, action) => {
      const { searchlist } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.searchlist = searchlist;
    },
    ActivityListFetched: (state, action) => {
      const { activitylist } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.activitylist = activitylist;
    },
    CaptionListFetched: (state, action) => {
      const { captionslist } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.captionslist = captionslist;
    },
    ChannelsListFetched: (state, action) => {
      const { channelslist } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.channelslist = channelslist;
    },
    ChannelSectionListFetched: (state, action) => {
      const { channelsectionlist } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.channelsectionlist = channelsectionlist;
    },
    CommentsListFetched: (state, action) => {
      const { commentslist } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.commentslist = commentslist;
    },
    i18nLanguageListFetched: (state, action) => {
      const { i18nlanguagelist } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.i18nlanguagelist = i18nlanguagelist;
    },
    i18nRegionListFetched: (state, action) => {
      const { i18nregionslist } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.i18nregionslist = i18nregionslist;
    },
    PlaylistItemsListFetched: (state, action) => {
      const { playlistitemslist } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.playlistitemslist = playlistitemslist;
    },
    PlaylistsListFetched: (state, action) => {
      const { playlistslist } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.playlistslist = playlistslist;
    },
    VideoCategoriesListFetched: (state, action) => {
      const { videocategorieslist } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.videocategorieslist = videocategorieslist;
    },
    VideosListFetched: (state, action) => {
      const { videoslist } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.videoslist = videoslist;
    },
  }
});